import { StatePreV13, StateV13 } from './13_zahlung_businessform_changed.interface';

export const zahlungBusinessformChanged = (
  previousState: StatePreV13,
  newVersion: number,
): StateV13 => {
  const newState: StateV13 = {
    ...previousState,
    version: newVersion,
    zahlung: {
      ...previousState.zahlung,
      kontoinhaber: {
        ...previousState.zahlung.kontoinhaber,
        businessForm: {
          text: previousState.zahlung.kontoinhaber?.businessForm,
          wert: '',
        },
        juristisch: previousState.zahlung.kontoinhaber?.juristisch,
      },
    },
  };
  if (!previousState.zahlung.kontoinhaber?.juristisch) {
    newState.zahlung.kontoinhaber.businessForm = null;
  }
  return newState;
};
